const MuiSvgViewBox = 44;
const createRelativeSvgStokeWidth = (size, strokeWidth) => {
    // parseInt is a pretty rudimentary way of removing the "px" part of a value
    return `calc(${MuiSvgViewBox} / ${Number.parseInt(size)} * ${strokeWidth})`;
};
export const emptyCircularProgressPresets = {
    size: {
        xs: {},
        sm: {},
        md: {},
        lg: {},
        xl: {},
    },
};
export const circularProgressPresets = (tokens) => {
    const { loadingIndicator } = tokens.component;
    return {
        size: {
            xs: {
                size: loadingIndicator.circular.xs.width.value,
                sx: {
                    "& svg circle": {
                        strokeWidth: createRelativeSvgStokeWidth(loadingIndicator.circular.xs.width.value, loadingIndicator.circular.xs.strokeWidth.value),
                    },
                },
            },
            sm: {
                size: loadingIndicator.circular.sm.width.value,
                sx: {
                    "& svg circle": {
                        strokeWidth: createRelativeSvgStokeWidth(loadingIndicator.circular.sm.width.value, loadingIndicator.circular.sm.strokeWidth.value),
                    },
                },
            },
            md: {
                size: loadingIndicator.circular.md.width.value,
                sx: {
                    "& svg circle": {
                        strokeWidth: createRelativeSvgStokeWidth(loadingIndicator.circular.md.width.value, loadingIndicator.circular.md.strokeWidth.value),
                    },
                },
            },
            lg: {
                size: loadingIndicator.circular.lg.width.value,
                sx: {
                    "& svg circle": {
                        strokeWidth: createRelativeSvgStokeWidth(loadingIndicator.circular.lg.width.value, loadingIndicator.circular.lg.strokeWidth.value),
                    },
                },
            },
            xl: {
                size: loadingIndicator.circular.xl.width.value,
                sx: {
                    "& svg circle": {
                        strokeWidth: createRelativeSvgStokeWidth(loadingIndicator.circular.xl.width.value, loadingIndicator.circular.xl.strokeWidth.value),
                    },
                },
            },
        },
    };
};
export const emptyLinearProgressPresets = {
    size: {
        sm: {},
        md: {},
        lg: {},
    },
};
export const linearProgressPresets = (tokens) => {
    const { loadingIndicator } = tokens.component;
    return {
        size: {
            sm: { sx: { height: loadingIndicator.linear.sm.height.value } },
            md: { sx: { height: loadingIndicator.linear.md.height.value } },
            lg: { sx: { height: loadingIndicator.linear.lg.height.value } },
        },
    };
};
//# sourceMappingURL=loadingIndicator.js.map